



















import {Component, Vue} from "vue-property-decorator";
import Cta from "@/components/cta.vue";
import {deleteCookie, getCookie, setCookie} from "@/utilities/utilities";
import i18n from "@/plugins/i18n";
import {State} from "vuex-class";

@Component({
    components: {Cta}
}) export default class extends Vue {
    payment:any = null;
    @State('reservationId') reservationId;
    @State('search') search;
    message = null;

    async beforeMount() {
        this.payment = await this.$api.get('getpaystatus', {
            Reservation_id: this.reservationId,
            Xaction_id: this.$parent['Xaction_id'] || this.search['transid']
        });
        
        if(this.payment.PaymentStatus === 10 || this.payment.PaymentStatus === 3) {
            deleteCookie('reservationId');
        }

    }

    get isSucces() {
        return this.payment.PaymentStatus === 10 || this.payment.PaymentStatus === 3;
    }
}
